import React, { useState } from "react";
import PropTypes from "prop-types";
import { onboardingData } from "./stages";

export const MatchesOnboardingPopup = ({ handleClose }) => {
  const [activeStage, setActiveStage] = useState(1);

  const stages = onboardingData.map((stage, index) => (
    <div
      key={stage.title + index}
      className={
        activeStage === 1 + index
          ? "matches-onboarding-popup__info isActive"
          : "matches-onboarding-popup__info"
      }
    >
      <img
        className="matches-onboarding-popup__info__image"
        alt={stage.title}
        src={stage.img}
      />
      <h2 className="matches-onboarding-popup__info__title">{stage.title}</h2>
      <p className="matches-onboarding-popup__info__copy">{stage.copy}</p>
    </div>
  ));

  return (
    <div className="matches-onboarding-popup">
      {stages}
      <p className="matches-onboarding-popup__count">
        {activeStage} / {onboardingData.length}
      </p>
      <button
        className="button button--light"
        onClick={() =>
          activeStage < onboardingData.length
            ? setActiveStage(activeStage + 1)
            : handleClose()
        }
      >
        {activeStage < onboardingData.length ? "Next step" : "Start now"}
      </button>
    </div>
  );
};

MatchesOnboardingPopup.propTypes = {
  handleClose: PropTypes.func.isRequired,
};

export default MatchesOnboardingPopup;
